import { type ReactNode } from 'react';
import {
  type Frequency,
  type Price,
} from '@bbkPricingPage/types/pricing-table-types';
import { AddonItem } from './addon-item';
import { ChargeItem } from './charge-item';

type AddonsData = {
  id: string;
  name: string;
  description?: string;
  price: Price;
  quantity: number | undefined;
  isMandatory: boolean;
  isCharge: boolean;
};

export const AddonSection = ({
  title,
  frequency,
  selectedAddons,
  applicableAddons,
  applicableCharges,
  toggleAddon,
  updateAddonQuantity,
  selectedPlanId,
}: {
  title: ReactNode;
  frequency: Frequency;
  selectedAddons: Map<string, { addonId: string; quantity: number }>;
  applicableAddons?: AddonsData[];
  applicableCharges?: AddonsData[];
  toggleAddon: (addonId: string) => void;
  updateAddonQuantity: (addonId: string, quantity: number) => void;
  selectedPlanId: string;
}) => {
  if (!applicableCharges?.length && !applicableAddons?.length) return null;
  return (
    <div className="tw-mb-4">
      <span className="tw-mb-2 tw-flex tw-items-center tw-text-lg tw-font-semibold tw-text-[var(--pricing-page-text-font-text-color)]">
        {title}
      </span>

      <div className="tw-space-y-2 tw-divide-y tw-divide-[color-mix(in_srgb,var(--pricingtable-style-accent-color)_20%,transparent)] tw-rounded-pricingtable-border-radius tw-border tw-border-[color-mix(in_srgb,var(--pricingtable-style-accent-color)_50%,transparent)] tw-bg-[color-mix(in_srgb,var(--pricingtable-style-accent-color)_5%,transparent)] tw-p-4">
        {applicableAddons?.map(
          ({ id, name, description, price, quantity, isMandatory }) => {
            const isSelected = isMandatory || selectedAddons.has(id);

            return (
              <AddonItem
                key={price.billing_system_id}
                name={name}
                description={description}
                frequency={frequency}
                addonPrice={price}
                isToggleEnabled={isSelected}
                quantity={quantity}
                onToggle={() => toggleAddon(id)}
                onQuantityChange={(qty) => updateAddonQuantity(id, qty)}
                isMandatory={isMandatory}
                selectedPlanId={selectedPlanId}
              />
            );
          }
        )}
        {applicableCharges?.map(({ name, description, price, quantity }) => {
          return (
            <ChargeItem
              key={price.billing_system_id}
              name={name}
              description={description}
              quantity={quantity}
              chargePrice={price}
              frequency={frequency}
            />
          );
        })}
      </div>
    </div>
  );
};
